export default "__VITE_ASSET__7fcbbf22__"